/* The way in, and the way somebody is told they are not coming in.
 *
 * Two states in one component because they are one moment: signing in as an
 * account with no platform_admins row is not an error, it is the ordinary
 * outcome for every station account in the product, and the screen should say so
 * plainly rather than looking like a failure.
 *
 * The refusal is honest about what it is. It does not say "invalid credentials"
 * — the credentials were fine — and it does not pretend the app does not exist.
 * The database is what refuses; this only reads the same answer the policies do.
 */
import * as Vue from 'vue';
import { api } from '../api.js';

export const SignIn = {
  name: 'AdminSignIn',
  setup: function () {
    var email = Vue.ref('');
    var password = Vue.ref('');

    async function submit() {
      if (!email.value || !password.value) return;
      var okay = await api.signIn(email.value.trim(), password.value);
      if (okay) password.value = '';
    }

    return {
      email: email,
      password: password,
      submit: submit,
      auth: api.auth,
      signOut: api.signOut
    };
  },
  template: [
    '<div class="gate">',
    '  <div class="gate__card">',
    '    <h1 class="gate__brand">TurnWizard <span>Admin</span></h1>',
    '',
    /* Signed in, but not one of the named users. */
    '    <template v-if="auth.user && !auth.isAdmin">',
    '      <p class="gate__lead">Signed in as <strong>{{ auth.user.email }}</strong>, which is not',
    '        an admin account.</p>',
    '      <p class="gate__hint">This app is limited to the accounts listed in',
    '        <code>platform_admins</code>. A salon&rsquo;s own sign-in reaches the console at',
    '        its own address; it has no access here and would see nothing if it did &mdash;',
    '        every table is filtered by the same rule that refuses this page.</p>',
    '      <div class="gate__row">',
    '        <button type="button" class="btn btn--ghost" @click="signOut">Sign out</button>',
    '      </div>',
    '    </template>',
    '',
    '    <template v-else>',
    '      <p class="gate__lead">Tenant management for TurnWizard.</p>',
    '      <form class="gate__form" @submit.prevent="submit">',
    '        <label class="field">',
    '          <span class="field__label">Email</span>',
    '          <input v-model="email" class="input" type="email" autocomplete="username"',
    '            spellcheck="false" placeholder="you@example.com" />',
    '        </label>',
    '        <label class="field">',
    '          <span class="field__label">Password</span>',
    '          <input v-model="password" class="input" type="password"',
    '            autocomplete="current-password" />',
    '        </label>',
    '        <button type="submit" class="btn btn--primary" :disabled="auth.busy">',
    '          {{ auth.busy ? "Signing in…" : "Sign in" }}</button>',
    '      </form>',
    '      <p v-if="auth.error" class="warn-line">{{ auth.error }}</p>',
    '    </template>',
    '  </div>',
    '</div>'
  ].join('\n')
};
